"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromUpdateInstanceSettingsToUpdate = exports.isUpdateInstanceSettings = exports.fromUpdateInstanceNameToUpdate = exports.isUpdateInstanceName = exports.fromUpdateInstanceSubscriptionToUpdate = exports.isUpdateInstanceSubscription = exports.isDeleteInstance = exports.isUpdateInstance = exports.isUpdateInstanceStack = exports.isCreateInstanceStack = exports.isPrivateInstanceDetails = exports.isPrivateInstancePreview = void 0;
const lodash_1 = __importDefault(require("lodash"));
const uuid_1 = require("../types/uuid");
const instances_1 = require("./instances");
const stacks_1 = require("./stacks");
const teams_1 = require("../schema/teams");
const validation_1 = require("../validator/validation");
const InstanceSize_1 = require("./InstanceSize");
const QueryLimits_1 = require("./QueryLimits");
const subdomain_1 = require("../types/subdomain");
const commonInstanceFields = {
    id: uuid_1.isUUID,
    name: validation_1.isString,
    stack: (0, validation_1.optional)(stacks_1.isStack),
    state: instances_1.isInstanceState,
    group: teams_1.isInstanceGroupInfo,
};
exports.isPrivateInstancePreview = validation_1.isObject.which((0, validation_1.isSomeOf)((0, validation_1.hasFields)({
    type: (0, validation_1.isLiteral)(instances_1.InstanceType.Sandbox),
    ...commonInstanceFields,
}), (0, validation_1.hasFields)({
    type: (0, validation_1.isLiteral)(instances_1.InstanceType.Production, instances_1.InstanceType.Developer),
    team: teams_1.isTeamInfo,
    ...commonInstanceFields,
})));
exports.isPrivateInstanceDetails = (0, validation_1.isAllOf)(instances_1.isInstanceDetails, (0, validation_1.isObjectOf)({
    stack: (0, validation_1.optional)(stacks_1.isPartialStack),
    group: teams_1.isInstanceGroupInfo,
    limits: (0, validation_1.optional)(QueryLimits_1.isQueryLimits),
    baseStorage: validation_1.isNumber,
    extraStorage: validation_1.isNumber,
}));
exports.isCreateInstanceStack = (0, validation_1.isObjectOf)({
    instanceSize: InstanceSize_1.isInstanceSize,
    applicationVersion: validation_1.isString,
});
exports.isUpdateInstanceStack = exports.isCreateInstanceStack;
exports.isUpdateInstance = (0, validation_1.isAllOf)((0, validation_1.isObjectOf)({
    name: (0, validation_1.optional)(subdomain_1.isSubdomain),
    instanceType: instances_1.isInstanceType,
    baseStorage: (0, validation_1.optional)(validation_1.isNumber
        .which((0, validation_1.satisfiesCondition)(n => Number.isInteger(n) && n >= 1))),
    extraStorage: (0, validation_1.optional)(validation_1.isNumber
        .which((0, validation_1.satisfiesCondition)(n => Number.isInteger(n) && n >= 0))),
}), (0, validation_1.isPartialObjectOf)({
    limits: QueryLimits_1.isQueryLimits,
}));
exports.isDeleteInstance = (0, validation_1.isObjectOf)({
    delete: (0, validation_1.isLiteral)(true),
});
exports.isUpdateInstanceSubscription = validation_1.isObject.which((0, validation_1.isSomeOf)((0, validation_1.hasFields)({
    instanceType: (0, validation_1.isLiteral)(instances_1.InstanceType.Sandbox).or((0, validation_1.isLiteral)(instances_1.InstanceType.Developer)),
}), (0, validation_1.hasFields)({
    instanceType: (0, validation_1.isLiteral)(instances_1.InstanceType.Production),
    extraStorage: (0, validation_1.optional)(validation_1.isNumber
        .which((0, validation_1.satisfiesCondition)(n => Number.isInteger(n) && n >= 0))),
})));
function fromUpdateInstanceSubscriptionToUpdate(op, instance, storage) {
    const { baseStorage } = storage;
    let extraStorage = 0;
    if (op.instanceType === instances_1.InstanceType.Production &&
        !lodash_1.default.isNil(op.extraStorage)) {
        extraStorage = op.extraStorage;
    }
    return {
        name: instance.name,
        instanceType: op.instanceType,
        baseStorage,
        extraStorage,
    };
}
exports.fromUpdateInstanceSubscriptionToUpdate = fromUpdateInstanceSubscriptionToUpdate;
exports.isUpdateInstanceName = (0, validation_1.isObjectOf)({
    name: subdomain_1.isSubdomain,
});
function fromUpdateInstanceNameToUpdate(op, instance, storage) {
    const { baseStorage } = storage;
    return {
        ...instance,
        instanceType: instance.type,
        baseStorage,
        name: op.name,
    };
}
exports.fromUpdateInstanceNameToUpdate = fromUpdateInstanceNameToUpdate;
exports.isUpdateInstanceSettings = (0, validation_1.isObjectOf)({
    baseStorage: (0, validation_1.optional)(validation_1.isNumber
        .which((0, validation_1.satisfiesCondition)(n => Number.isInteger(n) && n >= 1))),
});
function fromUpdateInstanceSettingsToUpdate(op, instance, storage) {
    return {
        ...instance,
        instanceType: instance.type,
        ...storage,
        ...op,
    };
}
exports.fromUpdateInstanceSettingsToUpdate = fromUpdateInstanceSettingsToUpdate;
//# sourceMappingURL=private.js.map